
<ng-container *transloco="let t; read: 'common'">

  <div class="row">
    <div class="col col-12 mx-auto">
      <div style="width: 100%; height: 100%; position:fixed" id="hotel_map"></div>
    </div>
    <div style="z-index: 9999;" id="popup" class="ol-popup">
      <a href="#" id="popup-closer" class="ol-popup-closer"></a>
      <div id="popup-content"></div>
    </div>

      <div class="col col-12 col-md-3 offset-md-9" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
        <div class="my-panel" style="float: right">
          <table>
            <tr>
              <td><img style="margin-top: -0.3rem; margin-right: 0.3rem;  max-width: 1.3rem;" src="assets/images/common.png"/><span>{{t('place')}}</span></td>
              <td><img style="margin-top: -0.3rem; margin-right: 0.3rem;  max-width: 1.3rem;" src="assets/images/video.png" alt="video-icon"/> <span>{{t('video')}}</span></td>
              <td><img style="margin-top: -0.3rem; margin-right: 0.3rem;  max-width: 1.3rem;" src="assets/images/audio.png" alt="audio-icon"/> <span>{{t('audio')}}</span></td>
              <td><img style="margin-top: -0.3rem; margin-right: 0.3rem; max-width: 1.3rem;" src="assets/images/document.png" alt="doc-icon"/> <span>{{t('document')}}</span></td>
              <td><img style="margin-top: -0.3rem; margin-right: 0.3rem;  max-width: 1.3rem;" src="assets/images/camara.png" alt="img-icon"/> <span>{{t('photo')}}</span></td>
            </tr>
          </table>
        </div>
    </div>



    <div style="margin-top: -2rem;" class="col col-7 col-md-3 col-lg-2 offset-5 offset-md-9 offset-lg-10">
      <div class="my-panel" style="float: right; display: inline;">
          <button (click)="openSearchModal()"  type="button" class="small-button btn btn-primary">
            <i class="fa fa-fw fa-search"></i>
          </button>
          <button *ngIf="activeSearch" style="margin-left: 0.5rem" (click)="clearSearch()"  type="button" class="small-button btn btn-alt">
            <i class="fa fa-fw fa-times"></i>
          </button>
          <button  style="margin-left: 0.5rem" (click)="openResourcesModal()"  type="button" class="small-button btn btn-primary">
            <i class="fa fa-fw fa-eye"></i>
          </button>
          <button  style="margin-left: 0.5rem" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed"
          aria-controls="collapseExample"  type="button" class="small-button btn btn-primary">
            <i class="fa fa-fw fa-info"></i>
          </button>
      </div>
    </div>
    

  </div>
  <div class="row">


  </div>
  <div style="margin-top: 0.5rem;" class="row">


  </div>
</ng-container>




